import React from 'react';

const homeFaqsEN = [
  {
    question: 'What is SAPOT AI?',
    answer: (
      <>
        SAPOT AI is an AI-powered sales intelligence platform that captures offline, face-to-face conversations and transforms them into structured, actionable business data.
      </>
    )
  },
  {
    question: 'What is the SAPOT Note device?',
    answer: (
      <>
        SAPOT Note is an AI-powered voice recording device designed to capture offline conversations with crystal-clear audio quality.
        <br /><br />
        It features dual microphones, over 10 hours of battery life, 32GB of internal storage, and one-touch recording. The device includes both a pin clip and a magnetic attachment for flexible use.
      </>
    )
  },
  {
    question: 'What pricing plans are available?',
    answer: (
      <>
        &bull; <strong>Standard</strong> &ndash; RM300/month per account
        <br />
        Personal dashboard and individual performance tracking.
        <br /><br />
        &bull; <strong>Team</strong> &ndash; RM600/month per account <em>(Most Popular)</em>
        <br />
        Built for team management with admin controls and team analytics.
        <br />
        <strong>Minimum purchase: 5 accounts to start.</strong>
        <br /><br />
        &bull; <strong>Enterprise</strong> &ndash; RM900/month per account
        <br />
        Full customization, CRM integration, unlimited manager accounts, AI coaching, and dedicated enterprise support.
        <br />
        <strong>Minimum purchase: 10 accounts to start.</strong>
      </>
    )
  },
  {
    question: 'What is included in the Professional plan?',
    answer: (
      <>
        The Professional plan is built for growing sales teams:
        <br /><br />
        &bull; Unlimited recordings
        <br />
        &bull; Full AI analysis &amp; coaching
        <br />
        &bull; Auto follow-up
        <br />
        &bull; Survey management
        <br />
        &bull; SQL Agent
        <br />
        &bull; Priority support
        <br /><br />
        🎁 Annual plan bonus: 1 FREE SAPOT Note device ($200 value)
      </>
    )
  },
  {
    question: 'What is included in the Enterprise plan?',
    answer: (
      <>
        The Enterprise plan is designed for large organizations:
        <br /><br />
        &bull; Everything in Professional
        <br />
        &bull; Unlimited teams &amp; users
        <br />
        &bull; Custom integrations
        <br />
        &bull; New feature request
        <br />
        &bull; Dedicated account manager
        <br />
        &bull; SLA guarantee
        <br />
        &bull; On-premise deployment option
      </>
    )
  },
  {
    question: 'Is there a discount for annual billing?',
    answer: (
      <>
        Yes. Annual billing reduces cost from:
        <br /><br />
        &bull; $600/year &rarr; $480/year per account
        <br /><br />
        Plus you receive 1 free SAPOT Note device ($200 value) with annual Professional plan.
      </>
    )
  },
  {
    question: 'How does AI conversation analysis work?',
    answer: (
      <>
        SAPOT AI automatically analyzes sales conversations to capture customer intent, identify successful patterns, and deliver data-driven recommendations. Each conversation is scored based on five core sales skill categories.
      </>
    )
  },
  {
    question: 'What are the 5 skill categories used to assess sales performance?',
    answer: (
      <>
        SAPOT AI evaluates sales performance across the following five skill categories:
        <br /><br />
        <span style={{ color: '#3B82F6' }}>1.</span> Communication balance
        <br />
        <span style={{ color: '#3B82F6' }}>2.</span> Customer engagement
        <br />
        <span style={{ color: '#3B82F6' }}>3.</span> Objection handling
        <br />
        <span style={{ color: '#3B82F6' }}>4.</span> Conversion skills
        <br />
        <span style={{ color: '#3B82F6' }}>5.</span> Product knowledge
      </>
    )
  },
  {
    question: 'Is my data secure with SAPOT AI?',
    answer: (
      <>
        Yes. All conversation data is securely stored and shared exclusively between you and the authorized salesperson or management team.
      </>
    )
  },
  {
    question: 'How accurate is the conversation analysis?',
    answer: (
      <>
        SAPOT AI delivers highly accurate analysis when supported by high-quality audio input. Our advanced speech recognition technology continuously learns and improves to better identify key sales moments and customer intent.
      </>
    )
  },
  {
    question: 'Can SAPOT AI be used for compliance monitoring?',
    answer: (
      <>
        Yes. SAPOT AI includes compliance and quality monitoring features that track adherence to sales processes and automatically flag deviations from standard procedures.
      </>
    )
  },
  {
    question: 'What languages does SAPOT AI support?',
    answer: (
      <>
        SAPOT AI supports 70+ languages for transcription and analysis, including English, Chinese, and Malay.
        <br /><br />
        It also understands local variations and conversational nuances, such as Malaysian-style language, to ensure accurate insights into every market.
      </>
    )
  },
  {
    question: 'How do I get started with SAPOT AI?',
    answer: (
      <>
        Getting started is simple:
        <br /><br />
        <span style={{ color: '#3B82F6' }}>1.</span> Choose a plan — <strong>Professional</strong> (monthly or annual) or <strong>Enterprise</strong>
        <br />
        <span style={{ color: '#3B82F6' }}>2.</span> Set up SAPOT Note device(s)
        <br />
        <span style={{ color: '#3B82F6' }}>3.</span> Start capturing and improving every sales conversation
      </>
    )
  }
];

const homeFaqsZH = [
  {
    question: '什么是 SAPOT AI？',
    answer: (
      <>
        SAPOT AI 是一款由人工智能驱动的销售情报平台，能够捕捉线下面对面的对话，并将其转化为结构化、可执行的业务数据。
      </>
    )
  },
  {
    question: 'SAPOT Note 设备是什么？',
    answer: (
      <>
        SAPOT Note 是一款由 AI 驱动的录音设备，专为捕捉线下对话而设计，能够提供清晰的音质。
        <br /><br />
        它配备双麦克风，续航超过 10 小时，内置 32GB 存储空间，支持一键录音。设备同时配有别针和磁吸两种佩戴方式，使用灵活。
      </>
    )
  },
  {
    question: '有哪些套餐方案可供选择？',
    answer: (
      <>
        &bull; <strong>标准版（Standard）</strong> &ndash; 每个账户每月 RM300
        <br />
        个人仪表板与个人绩效跟踪。
        <br /><br />
        &bull; <strong>团队版（Team）</strong> &ndash; 每个账户每月 RM600 <em>（最受欢迎）</em>
        <br />
        专为团队管理打造，具备管理员权限与团队分析功能。
        <br />
        <strong>起订数量：5 个账户起。</strong>
        <br /><br />
        &bull; <strong>企业版（Enterprise）</strong> &ndash; 每个账户每月 RM900
        <br />
        全面定制、CRM 集成、无限管理员账户、AI 教练辅导以及专属企业级支持。
        <br />
        <strong>起订数量：10 个账户起。</strong>
      </>
    )
  },
  {
    question: '专业版（Professional）包含哪些内容？',
    answer: (
      <>
        专业版专为成长中的销售团队打造：
        <br /><br />
        &bull; 无限次录音
        <br />
        &bull; 完整的 AI 分析与辅导
        <br />
        &bull; 自动跟进
        <br />
        &bull; 问卷管理
        <br />
        &bull; SQL Agent
        <br />
        &bull; 优先客户支持
        <br /><br />
        🎁 年付方案赠礼：免费赠送 1 台 SAPOT Note 设备（价值 $200）
      </>
    )
  },
  {
    question: '企业版（Enterprise）包含哪些内容？',
    answer: (
      <>
        企业版专为大型企业组织设计：
        <br /><br />
        &bull; 包含专业版全部功能
        <br />
        &bull; 无限团队与用户数
        <br />
        &bull; 定制化集成
        <br />
        &bull; 新功能需求
        <br />
        &bull; 专属客户经理
        <br />
        &bull; SLA 服务保障
        <br />
        &bull; 本地部署方案
      </>
    )
  },
  {
    question: '年付方案有优惠吗？',
    answer: (
      <>
        有。年付可将费用从：
        <br /><br />
        &bull; 每账户 $600/年 &rarr; $480/年
        <br /><br />
        此外，订购专业版年付方案还将获赠 1 台 SAPOT Note 设备（价值 $200）。
      </>
    )
  },
  {
    question: 'AI 对话分析是如何运作的？',
    answer: (
      <>
        SAPOT AI 会自动分析销售对话，捕捉客户意图、识别成功模式，并提供基于数据的建议。每一段对话都会根据五大核心销售技能维度进行评分。
      </>
    )
  },
  {
    question: '用于评估销售表现的 5 大技能维度是什么？',
    answer: (
      <>
        SAPOT AI 从以下五大技能维度评估销售表现：
        <br /><br />
        <span style={{ color: '#3B82F6' }}>1.</span> 沟通平衡度
        <br />
        <span style={{ color: '#3B82F6' }}>2.</span> 客户互动
        <br />
        <span style={{ color: '#3B82F6' }}>3.</span> 异议处理
        <br />
        <span style={{ color: '#3B82F6' }}>4.</span> 转化能力
        <br />
        <span style={{ color: '#3B82F6' }}>5.</span> 产品知识
      </>
    )
  },
  {
    question: '我的数据在 SAPOT AI 中安全吗？',
    answer: (
      <>
        是的。所有对话数据均经过安全存储，仅在您本人与授权的销售人员或管理团队之间共享。
      </>
    )
  },
  {
    question: '对话分析的准确度如何？',
    answer: (
      <>
        在高质量音频输入的支持下，SAPOT AI 能够提供非常准确的分析。我们先进的语音识别技术会持续学习并不断优化，以更好地识别关键销售节点和客户意图。
      </>
    )
  },
  {
    question: 'SAPOT AI 可以用于合规监控吗？',
    answer: (
      <>
        可以。SAPOT AI 提供合规与质量监控功能，可跟踪销售流程的执行情况，并自动标记偏离标准流程的行为。
      </>
    )
  },
  {
    question: 'SAPOT AI 支持哪些语言？',
    answer: (
      <>
        SAPOT AI 支持 70 余种语言的转录与分析，包括英语、中文和马来语。
        <br /><br />
        同时也能理解当地的语言变体和对话细微差别，例如马来西亚式语言，确保为每个市场提供准确的洞察。
      </>
    )
  },
  {
    question: '我该如何开始使用 SAPOT AI？',
    answer: (
      <>
        开始使用非常简单：
        <br /><br />
        <span style={{ color: '#3B82F6' }}>1.</span> 选择套餐 —— <strong>专业版</strong>（按月或按年付费）或 <strong>企业版</strong>
        <br />
        <span style={{ color: '#3B82F6' }}>2.</span> 配置 SAPOT Note 设备
        <br />
        <span style={{ color: '#3B82F6' }}>3.</span> 开始捕捉并优化每一次销售对话
      </>
    )
  }
];

export const getHomeFaqs = (lang) => (lang === 'zh' ? homeFaqsZH : homeFaqsEN);

// Backwards-compat export (other agents will migrate callers to getHomeFaqs)
export const homeFaqs = homeFaqsEN;
